export default class {
    constructor() {
        this.privateDMP = 0;
        this.corporateDMP = 0;
        this.partnerDMP = 0;
        this.parentClaims = [];
    }
}
